export const API_ENDPOINT = process.env.NODE_ENV === 'development' ? 'http://localhost:9191' : 'https://zenflow-docs-content.appspot.com';
